import React from "react";
import { getVaultXDisplay, VAULTX_ICON_SRC } from "../utils/vaultxDisplay.js";

export default function VaultXTypeLabel({
  classification,
  leading = null,
  className = "",
}) {
  const display = getVaultXDisplay(classification);
  if (!display) return null;

  return (
    <span
      className={`inline-flex min-w-0 items-start gap-2 text-left font-semibold text-blue-600 ${className}`}
    >
      {leading ? (
        <span className="mt-0.5 flex-shrink-0" aria-hidden="true">
          {leading}
        </span>
      ) : null}
      <img
        src={VAULTX_ICON_SRC}
        alt="VaultX"
        className="mt-0.5 h-5 w-auto max-w-[2.75rem] flex-shrink-0 object-contain object-left"
        draggable={false}
        onError={(event) => {
          event.currentTarget.style.display = "none";
        }}
      />
      <span className="min-w-0 leading-tight">
        <span className="block whitespace-normal break-words">
          {display.title}
        </span>
        <span className="block whitespace-normal break-words text-[11px] font-medium text-blue-700/90">
          {display.subtitle}
        </span>
      </span>
    </span>
  );
}
